module.exports = __webpack_public_path__ + "img/featured-01.6bc12b80.jpg";